var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useState } from 'react';
import { C } from '#integrations';
import { AlertTriangleIcon, CheckCircleIcon, InfoCircleIcon, SpinnerIcon, XCloseIcon, } from '../../../icons';
import { useToastService } from '../../context';
import { ToastTestIdFactory } from '../../interactions';
import { FADE_ANIMATION_DURATION, TOAST_DISMISS_TIMEOUTS, TOAST_KIND, } from '../../Toast.constants';
import { ToastContent } from '../ToastContent';
import styles from './Toast.module.css';
const KIND_BORDER_CLASS_MAP = {
    negative: styles.BorderNegative,
    informative: styles.BorderInformative,
    progressive: styles.BorderProgressive,
    positive: styles.BorderPositive,
};
const KIND_ICON_CLASS_MAP = {
    negative: styles.IconNegative,
    informative: styles.IconInformative,
    progressive: styles.IconProgressive,
    positive: styles.IconPositive,
};
const toastKindIconMap = {
    negative: AlertTriangleIcon,
    informative: InfoCircleIcon,
    progressive: SpinnerIcon,
    positive: CheckCircleIcon,
};
export const Toast = ({ toast: { actionComponent, content, 'data-testid': testId, dismissTempo = 'fast', hasCloseButton = false, id, kind = TOAST_KIND.INFORMATIVE, onClose, overrideIcon, }, }) => {
    _react_refresh_temp_2();
    const { removeToast } = useToastService();
    const borderStyleClass = KIND_BORDER_CLASS_MAP[kind];
    const iconStyleClass = KIND_ICON_CLASS_MAP[kind];
    const Icon = overrideIcon || toastKindIconMap[kind];
    const elementId = useId();
    const [shouldFadeOut, setShouldFadeOut] = useState(false);
    const getRole = () => {
        if (actionComponent) {
            return 'dialog';
        }
        if (kind === TOAST_KIND.NEGATIVE) {
            return 'alert';
        }
        return 'status';
    };
    const role = getRole();
    useEffect(() => {
        if (dismissTempo === 'never') {
            return;
        }
        const fadeOutAnimationTimer = setTimeout(() => {
            setShouldFadeOut(true);
        }, TOAST_DISMISS_TIMEOUTS[dismissTempo] + FADE_ANIMATION_DURATION);
        const removeToastTimer = setTimeout(() => {
            removeToast(id);
            if (onClose) {
                onClose(true);
            }
        }, TOAST_DISMISS_TIMEOUTS[dismissTempo] + 2 * FADE_ANIMATION_DURATION);
        return () => {
            clearTimeout(removeToastTimer);
            clearTimeout(fadeOutAnimationTimer);
        };
    }, [dismissTempo, id, onClose, removeToast]);
    return (_jsxs("div", { "aria-labelledby": elementId, className: C(styles.Container, borderStyleClass, shouldFadeOut ? styles.FadeOut : styles.FadeIn), "data-testid": ToastTestIdFactory.getToastTestId(testId), role: role, children: [_jsxs("div", { className: styles.IconAndContent, children: [_jsx(Icon, { className: iconStyleClass }), _jsx(ToastContent, { id: elementId, label: content.label, message: content.message, toastId: id })] }), _jsxs("div", { className: styles.Actions, children: [actionComponent, hasCloseButton || dismissTempo === 'never' ? (_jsx(XCloseIcon, { className: styles.CloseButton, "data-testid": ToastTestIdFactory.getToastCloseButtonTestId(testId), onClick: () => {
                            removeToast(id);
                            if (onClose) {
                                onClose(false);
                            }
                        } })) : null] })] }));
};
_react_refresh_temp_1 = Toast;
$RefreshReg$(_react_refresh_temp_1, "Toast");
_react_refresh_temp_2(Toast, "p3g8AgcxrdLQaLj3fcWklSrM0Hw=", false, () => [useToastService]);
